'use client';
import { useEffect, useState } from 'react';
import { Chapter } from '@/types/courseDt';
import { useProgress } from '@/hooks/useProgress';
import ProgressCircle from './ProgressCircle';

export default function ChapterProgress({ chapter }: { chapter: Chapter }) {
  const { progress } = useProgress();
  const [chapterProgress, setChapterProgress] = useState(0);

  useEffect(() => {
    const totalLessons = chapter?.lessons?.length ?? 0;
    let chapterTotalProgress = 0;

    chapter.lessons.forEach((lesson) => {
      const lessonProgress = progress?.lessonsProgress[lesson.lessonId.current];
      if (lessonProgress) {
        chapterTotalProgress += lessonProgress.progress;
      }
    });

    // Ensure the progress is not over 100%
    if (chapterTotalProgress > 100) {
      chapterTotalProgress = 100;
    }

    const chapterProgress = Math.round(chapterTotalProgress / totalLessons);
    setChapterProgress(chapterProgress);
  }, [progress]);

  return <ProgressCircle percentage={chapterProgress ?? 0} color="#222222" />;
}
